<template>
    <CCard>    
        <CCardBody>  
            <CCol sm="12" lg="12" style="padding-left: 0px; padding-right: 0px;">  
                <div class="content-wrapper">
                    <div id="app">
                   
                        <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                            <ejs-grid ref='refdata' :dataSource='datas' height='60vh' :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                :toolbar='toolbar' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                :editSettings='editSettings' :recordDoubleClick="recordDoubleClick" :beforeRender="beforeRender" :rowSelected='rowSelected' 
                                :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound">
                                <e-columns>                               
                                  <e-column field='invalid_bill_id' headerText='作廢單號' aria-required="true" :isPrimaryKey='true' width='140'></e-column>
                                  <e-column field='status' headerText='狀態' width='140'></e-column>                                            
                                  <e-column field='bill_id' headerText='入庫單號' width='140'></e-column>       
                                  <e-column field='total_bad_pages' headerText='數量合計' format="N0" textAlign="Right" width='140'></e-column> 
                                  <e-column field='create_date' headerText='建檔日期' width='180'></e-column>
                                  <e-column field='create_id' headerText='建檔人員' width='140'></e-column>
                                  <e-column field='modify_date' headerText='異動日期' width='180'></e-column>
                                  <e-column field='modify_id' headerText='異動人員' width='140'></e-column>
                                </e-columns>                              
                            </ejs-grid>
                        </ejs-tooltip>
                    </div>
                </div>
            </CCol>
            <div class="dialog">
                <div class="control-section">
                    <ejs-dialog ref="modalDialog" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' :header='e_isAdd ? "新增部生產作廢單" : "修改生產作廢單"' :buttons='e_chanel_buttons' 
                        width='70%'>
                        <div formGroup="orderForm">                      
                             <div id="app">                     
                                 <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                                  <ejs-grid ref='refdata' :dataSource='stock_datas' height='60vh' width="100%" :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                      :toolbar='toolbarStock' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                      :editSettings='editSettings' :recordDoubleClick="recordDoubleClick" :beforeRender="beforeRender" :rowSelected='rowStockSelected' 
                                      :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound">
                                      <e-columns>                               
                                        <e-column field='bill_id' headerText='入庫單號' aria-required="true" :isPrimaryKey='true' width='180'></e-column>
                                        <e-column field='bill_date'  format="yyyy-MM-dd" type="date" headerText='日期' width='160'></e-column>    
                                        <e-column field='production_bill_id' headerText='生產單號' width='150'></e-column>                                               
                                        <e-column field='bill_state_name' headerText='狀態' width='120'></e-column>    
                                        <e-column field='style_id' headerText='款式編號' width='130'></e-column>  
                                        <e-column field='std_pages' headerText='每卷張數' width='140' format="N0" textAlign="Right" ></e-column>  
                                        <e-column field='produce_pages' headerText='生產張數' width='140' format="N0" textAlign="Right" ></e-column>  
                                        <e-column field='start_label_no' headerText='起始序號' width='180'></e-column>  
                                        <e-column field='end_label_no' headerText='結束序號' width='180'></e-column>  
                                        <e-column field='warehouse_id' headerText='倉庫編號' width='130'></e-column>   
                                        <e-column field='production_unit_id' headerText='生產單位' width='130'></e-column> 
                                        <e-column field='total_bad_pages' headerText='壞品張數' width='160' format="N0" textAlign="Right" ></e-column>  
                                        <e-column field='real_total_pages' headerText='實際入庫張數' width='160' format="N0" textAlign="Right" ></e-column>  
                                        <e-column field='invalid_bill_id' headerText='作廢單號' width='180'></e-column>  
                                        <e-column field='create_date' headerText='建檔日期' width='180'></e-column>
                                        <e-column field='create_id' headerText='建檔人員' width='140'></e-column>
                                        <e-column field='modify_date' headerText='異動日期' width='180'></e-column>
                                        <e-column field='modify_id' headerText='異動人員' width='140'></e-column>
                                      </e-columns>                              
                                  </ejs-grid>
                              </ejs-tooltip>
                            </div> 
                           
                        </div>                
                    </ejs-dialog>
                </div>    
            </div>
            <div class="dialog">
                <div class="control-section">
                    <ejs-dialog ref="modalDialog_content" :showCloseIcon='true' :isModal='true' :closeOnEscape='true' :visible='false' :header='"生產作廢單[單筆編輯畫面]"' :buttons='e_buttons' 
                        width='70%'>
                        <div formGroup="orderForm">                      
                             <div id="app">                     
                                 <ejs-tooltip ref="tooltip" target=".e-rowcell" >
                                  <ejs-grid ref='refdata' :dataSource='stock_datas' height='60vh' width="100%" :allowExcelExport='true' :allowPaging='true' :allowSorting='true' :allowFiltering='true' :allowReordering='true'
                                      :toolbar='toolbarStock' :pageSettings='pageSettings' :filterSettings='filterSettings' :selectionSettings='selectionSettings' :toolbarClick="toolbarClick"
                                      :editSettings='editSettings' :recordDoubleClick="recordDoubleClick" :beforeRender="beforeRender" :rowSelected='rowStockSelected' 
                                      :queryCellInfo='onQueryCellInfo' :rowDataBound="onRowDataBound">
                                      <e-columns>                               
                                        <e-column field='bill_id' headerText='序號' aria-required="true" :isPrimaryKey='true' width='180'></e-column>                                       
                                        <e-column field='start_label_no' headerText='標籤序號' width='180'></e-column>  
                                        <e-column field='end_label_no' headerText='標籤捲編號' width='180'></e-column>  
                                        <e-column field='warehouse_id' headerText='備註' width='130'></e-column>                                          
                                      </e-columns>                              
                                  </ejs-grid>
                              </ejs-tooltip>
                            </div> 
                           
                        </div>                
                    </ejs-dialog>
                </div>    
            </div>

            <ejs-toast ref='toastRef' id='toast_type' :position='position'></ejs-toast>      
        </CCardBody>
    </CCard>  
</template>



<style lang="scss" src="../../scss/grid.scss"></style>
<script lang="ts">

import Vue from "vue";
import Loading from 'vue-loading-overlay';
import { DialogUtility } from '@syncfusion/ej2-popups';
import { ToastComponent } from "@syncfusion/ej2-vue-notifications";
import { L10n, setCulture, enableRipple } from '@syncfusion/ej2-base';
import { DialogPlugin, TooltipPlugin } from '@syncfusion/ej2-vue-popups';
import { GridPlugin, DetailRow, PdfExport, ExcelExport, Sort, Edit, Page, Filter, Reorder, Toolbar, Search } from "@syncfusion/ej2-vue-grids";


setCulture('en-US');
L10n.load({
  'en-US': {
    'pager': {
      'currentPageInfo': '',
      'totalItemsInfo': '{1} to {2} of {0}',
    },
    'grid': {
        'Print': '列印',
        'Search': '搜尋'
    }
  }
});

enableRipple(true);
Vue.use(DialogPlugin);
Vue.use(TooltipPlugin);
Vue.use(GridPlugin);
Vue.use(Loading);

let DialogObj   = undefined;
let Loader      = undefined;

export default {
  name: 'Department',
  components: {   
    'ejs-toast': ToastComponent
  },
  data: function () {
    return {
      e_selectRow : null, e_selectStockRow: null,
      e_isAdd: null, e_warehouse_id: null, e_warehouse_name: null, e_contact: null, e_contact_phone: null, e_address: null, e_state: null, e_memo: null,
      e_buttons: [
        {click: this.editOkClick, buttonModel: { content: '確認', isPrimary: true } }, 
        {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}
      ],
      e_chanel_buttons: [       
        {click: function() { this.hide(); },buttonModel: { content: '取消', isPrimary: false}}
      ],
      toolbarStock:   [
        { text: '載入', tooltipText: '載入', prefixIcon: 'e-btn-icon e-shapes e-icons e-icon-left', id: 'Load' , disabled: false }
      ],

      filterSettings: { type: 'CheckBox' },
      pageSettings: { pageSizes: [10, 50, 100, 200], pageCount: 4 },
      selectionSettings: { persistSelection: true },
      editSettings: { allowEditing: false, allowAdding: false, allowDeleting: false, showAddNewRow: false },
      toolbar: null,
      datas: [], stock_datas: [],
      position: { X: 'Right', Y: "Bottom" }, ShowBtn: false,
      imgPersonTemplate: function () { return { 
          template: Vue.component("imgPersonTemplate", {
          template:  `<div><div class="e-grid-empimg"><img :src="image" class='c-avatar-about-img' style='width:30px' /></div></div>`,
              data: function () { return { data: {}, usermale: 'usermale', userfemale: 'userfemale' }; },
          computed: {
              image: function() {
                  return this.data.img_url;
              }
          }
      })}},
    };
  },
  methods: {    
    toolbarClick: function (args) {
     
      if (args.item.id == 'Delete') {
        DialogObj = DialogUtility.confirm({
            title: '刪除資料',
            content: `確認是否要刪除${this.e_selectRow.invalid_bill_id}的資料嗎?`,
            okButton: {  text: '是', click: this.delOkClick },
            cancelButton: {  text: '否', click: this.delCancelClick },
            showCloseIcon: true,
            closeOnEscape: true,
            animationSettings: { effect: 'Fade' }
        });
      }
      if (args.item.id == 'Add') {    
        this.e_isAdd = true;
        this.e_warehouse_id = ""; this.e_warehouse_name = ""; this.e_contact = ""; this.e_contact_phone = ""; this.e_address = ""; this.e_memo = "";
        this.e_state = 1;   
        this.getLBStockCanBadList();
        this.$refs.modalDialog.show();    
      }
      if (args.item.id == 'Edit') {
        this.e_isAdd = false;
        this.$refs.modalDialog_content.show();    
      }
      if (args.item.id == "Export") {
        this.$refs.refdata.excelExport({ fileName:'部門資料.xlsx' });
      }   
      if (args.item.id == "Load") {
        this.addLBStockCanBadList(this.e_selectStockRow.bill_id);
      }
    },   
    onQueryCellInfo(args) {     
      if (args.cell) {
        args.cell.classList.add("tooltip-cell");
        args.cell.setAttribute("title", `${args.column.headerText}: ${args.data[args.column.field]}`);
      }
    },
    onRowDataBound(args) {
      if (args.data.state == 2) {
        args.row.style.backgroundColor = "rgba(255, 229, 255, 0.8)"; // 數量少於 3，淡紅色
      } 
    },     
    checkHeader: function() {       
      this.toolbar = this.e_state == 0 ? 
      [
        { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: false },
        { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_selectRow == undefined },
        { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_selectRow == undefined },   
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        'Print', 'Search'] : 
      [
        { text: '新增', tooltipText: '新增', prefixIcon: 'e-btn-icon e-add e-icons e-icon-left', id: 'Add' , disabled: false },
        { text: '修改', tooltipText: '修改', prefixIcon: 'e-btn-icon e-edit e-icons e-icon-left', id: 'Edit', disabled: this.e_selectRow == undefined },
        { text: '刪除', tooltipText: '刪除', prefixIcon: 'e-btn-icon e-delete e-icons e-icon-left', id: 'Delete', disabled: this.e_selectRow == undefined },
        { text: '匯出', tooltipText: '匯出', prefixIcon: 'e-btn-icon e-excelexport e-icons e-icon-left', id: 'Export' }, 
        'Print', 'Search']
    },
    rowStockSelected: function(args) { 
      this.e_selectStockRow = args.data; 
    },
    rowSelected: function(args) {            
      this.e_selectRow = args.data; 
      this.checkHeader();
    },
    delOkClick: function() {
      DialogObj.hide();
      this.showLoading();
      this.axios({
          method: 'delete',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBStock/BadList',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            bill_id : this.e_selectRow.bill_id,
            invalid_bill_id : this.e_selectRow.invalid_bill_id
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg('刪除成功!');         
        this.hideLoading();
        this.getLBStockBadList();
       
      })
      .catch((error) => { this.showError(error, true) }
      ) 
    },          
    delCancelClick: function() {
        DialogObj.hide();
    },    
    editOkClick: function() {     

      this.showLoading();
      this.axios({
          method: this.e_isAdd ? 'post' : 'put',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBWarehouse',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            warehouse_id: this.e_warehouse_id,
            warehouse_name: this.e_warehouse_name,
            contact: this.e_contact,
            contact_phone: this.e_contact_phone,
            address: this.e_address,
            memo:  this.e_memo,         
            state: this.e_state ? 1 : 2
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; } 
        this.showMsg(this.e_isAdd ? '新增成功!' : '修改成功!');     
        this.$refs.modalDialog.hide();    
        this.hideLoading();
        this.getLBWarehouse();
       
      })
      .catch((error) => { this.showError(error, true) }
      ) 

    },  
    recordDoubleClick: function () {         
      this.e_isAdd = false;
      this.$refs.modalDialog_content.show();  
    },
    beforeRender: function (args) {
      if (args.target.closest("td")) {
        this.$refs.tooltip.content = args.target.innerText;
      }
    },
    getLBStockBadList: function () {           
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBStock/BadList',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.hideLoading();         
          this.datas = response.data.datas      
          this.e_selectRow = null;
          this.checkHeader();
      })
      .catch((error) => { this.showError(error, true) }
      ) 
              
    },
    getLBStockCanBadList: function () {           
      this.showLoading();
      this.axios({
          method: 'get',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBStock/Main/CanBadList',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.hideLoading();         
          this.stock_datas = response.data.datas      
      })
      .catch((error) => { this.showError(error, true) }
      ) 
              
    },
    addLBStockCanBadList: function (bill_id) {           
      this.showLoading();
      this.axios({
          method: 'post',
          baseURL: Vue.prototype.GLOBAL.baseURL,
          url: 'LBStock/Main/CanBadList',
          headers: {'Content-Type' : 'application/json', 'Authorization' : `Bearer ${localStorage.getItem('token')}` },
          data : {
            bill_id: bill_id
          }
      })
      .then((response) => {       
        if (!response.data.ok) { this.$refs.toastRef.show( { title: '錯誤!', content: response.data.msg, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' }); return; }              
          this.hideLoading();      
          this.$refs.modalDialog.hide();  
          this.getLBStockBadList();      
      })
      .catch((error) => { this.showError(error, true) }
      ) 
              
    },



    

    showError: function (error) {     
      this.hideLoading();
      if (error.response.status == 400) {
        for(var key in error.response.data.errors){      
          this.$refs.toastRef.show( { title: '警告!', content: error.response.data.errors[key][0] , cssClass: 'e-toast-warning', icon: 'e-warning toast-icons' });           
        }
        return;
      }   
      if (error.response.status == 401) {
        localStorage.removeItem('token'); this.$router.push('/login');
        return;
      }
      this.$refs.toastRef.show( { title: '錯誤!', content: error.response.status, cssClass: 'e-toast-danger', icon: 'e-warning toast-icons' });
    },
    showMsg: function (msg) {
      this.$refs.toastRef.show( { title: '訊息!', content: msg, cssClass: 'e-toast-info', icon: 'e-info toast-icons' });
    },
    showLoading() {
      Loader = this.$loading.show({
        container: this.$refs.loadingContainer,
        canCancel: true, // default false
        onCancel: this.yourCallbackMethod,
        color: 'blue',
        loader: 'bars',  // spinner, dots, bars
        width: 164,
        height: 164,
        backgroundColor: 'black',
        opacity: 0.5,
        zIndex: 999,
      });
    },
    hideLoading() {
        Loader.hide();
    }
  },
  provide: {
    grid: [PdfExport, ExcelExport, Sort, DetailRow, Edit, Page, Toolbar, Filter, Reorder, Search]
  },
  created() {
    this.checkHeader();
    this.getLBStockBadList();
  },
  mounted() {
  },
  beforeUpdate() {
  },
  beforeDestroy() {
  }
}
</script>
<style>
/* 設定 CustomerName 欄位的字體顏色 */
.blue-text {
  color: blue !important;
}
</style>
<style lang="scss" src="../../scss/base.scss"></style>
